import { render, staticRenderFns } from "./LegalEdit.vue?vue&type=template&id=6aed85be&"
import script from "./LegalEdit.vue?vue&type=script&lang=js&"
export * from "./LegalEdit.vue?vue&type=script&lang=js&"
import style0 from "./LegalEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports